import { render, staticRenderFns } from "./userRoles.vue?vue&type=template&id=39599e51&scoped=true"
import script from "./userRoles.vue?vue&type=script&lang=js"
export * from "./userRoles.vue?vue&type=script&lang=js"
import style0 from "./userRoles.vue?vue&type=style&index=0&id=39599e51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39599e51",
  null
  
)

export default component.exports